import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { useEffect, useMemo } from 'react'
import { clearWorkerAvailability, getWorkerAvailability } from 'features/globalView/globalViewSlice'
import { tokens } from 'styling/tokens'
import { GLWidget } from './GLWidget'

const META = [
  { key: 'Free', color: tokens.status.success.fg, get: (w: any) => w?.free || 0 },
  { key: 'Busy', color: tokens.accent.base, get: (w: any) => w?.busy || 0 },
  { key: 'Absent', color: tokens.status.danger.fg, get: (w: any) => w?.absent || 0 },
]

export const GLEmployeesWidget = ({
  handleWidget,
  selectedStatus,
}: {
  selectedStatus: string
  handleWidget: (open: boolean, type: string) => void
}) => {
  const { workersAvailability } = useSelector((state: RootState) => state.globalView)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(getWorkerAvailability())
    return () => {
      dispatch(clearWorkerAvailability())
    }
  }, [])

  const allWorkers = useMemo(
    () => (workersAvailability?.free || 0) + (workersAvailability?.busy || 0) + (workersAvailability?.absent || 0),
    [workersAvailability],
  )
  const pct = (curr: number) => (allWorkers ? Math.round((curr / allWorkers) * 100) : 0)

  const rows = META.map((m) => {
    const value = m.get(workersAvailability)
    return {
      key: m.key,
      label: m.key,
      value,
      pct: pct(value),
      color: m.color,
      selected: selectedStatus == m.key,
      onClick: () => handleWidget(true, m.key),
    }
  })

  return <GLWidget title='Employees' onViewAll={() => handleWidget(true, null)} rows={rows} />
}
